import Vue from 'vue';
import VueRouter from 'vue-router';
import Dash from '../views/Dash.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Dash,
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
